import React from "react";

export const PredicateAlwaysTrueCheckbox = (props) => {
    const {isChecked, onCheck} = props;

    return (
        <div className='input-container'>
            <input type="checkbox"
                   name="alwaysTrue"
                   className="checkbox static-text"
                   checked={isChecked}
                   onChange={(e) => onCheck(e)}/>
            <label className='static-text' htmlFor="alwaysTrue">
                Always true
            </label>
        </div>
    )
}